// src/components/CameraStream.jsx
import React, { useEffect, useRef } from 'react';
import { useContext } from 'react';
import { MediaOverlayContext } from '../../context/MediaOverlayContext';
import DogPreTaggerOverlay from './DogPreTaggerOverlay';
import './CameraStream.css';

import activateOnKey from '../../utils/activateOnKey';

const CameraStream = ({ onCapture, onClose, onToggleMode, shotMode, lastPhoto }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const { photos, openPhotoEditor, preTaggedDogIds, availableDogs } = useContext(MediaOverlayContext);
  const lastValidPhoto = lastPhoto || (photos.length > 0 ? photos[photos.length - 1].src : null);



  useEffect(() => {
    const startCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { ideal: 'environment' } },
          audio: false
        });
        streamRef.current = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
        }
      } catch (err) {
        console.error('[CameraStream] Camera error:', err);
        alert('Unable to access camera.');
        onClose();
      }
    };

    startCamera();
    return () => streamRef.current?.getTracks().forEach(t => t.stop());
  }, [onClose]);


  // Inside useEffect of CameraStream.jsx
useEffect(() => {
  const setVH = () => {
    const vh = window.visualViewport?.height || window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${vh * 0.01}px`);
  };

  setVH();
  window.visualViewport?.addEventListener('resize', setVH);
  window.addEventListener('resize', setVH);

  return () => {
    window.visualViewport?.removeEventListener('resize', setVH);
    window.removeEventListener('resize', setVH);
  };
}, []);




  const handleSnap = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    if (!canvas || !video) return;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);
    const photo = canvas.toDataURL('image/png');


    const taggedDogs = availableDogs.filter(d => preTaggedDogIds.includes(d.id));

    console.log('<><><><><><><><><><>');
    console.log('<><><><><><><><><><>');
    console.log('taggedDogs', taggedDogs);
    console.log('<><><><><><><><><><>');
    console.log('<><><><><><><><><><>');


    onCapture(photo, { tags: taggedDogs });

  };

  return (
    <div className="camera-stream__container">
      <video ref={videoRef} className="camera-stream__video" playsInline autoPlay muted />
      <canvas ref={canvasRef} style={{ display: 'none' }} />

      <div className="camera-stream__overlay">
        <button className="camera-stream__btn camera-stream__btn--top-left" onClick={onClose}>✖</button>

        <button className="camera-stream__btn camera-stream__btn--bottom-center" onClick={handleSnap}></button>

        {lastValidPhoto ? (
          <div role="button" tabIndex={0} onKeyDown={activateOnKey}
            className="camera-stream__thumb"
            onClick={() => photos.length > 0 && openPhotoEditor(photos.length - 1)}
          >
            <img src={lastValidPhoto} alt="Last snap" />
          </div>
        ) : (
          <div className="camera-stream__thumb camera-stream__thumb--empty" />
        )}

        <DogPreTaggerOverlay />
      </div>
    </div>
  );
};

export default CameraStream;
